import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import moment from 'moment';
import { Form } from 'common/components';
import ImportActions from './ImportActions';

class ImportListRow extends Component {
  state = { collapsed: true };

  handleToggleCollapsed = () => this.setState({ collapsed: !this.state.collapsed });

  render = () => {
    const { record, t, handleReImportCSV, isImporting } = this.props;
    const { collapsed } = this.state;

    return (
      <Fragment>
        <tr>
          <td>{moment(record.createdAt).format('DD/MM/YYYY HH:mm:ss')}</td>
          <td
            className={classnames('text-center', {
              'table-warning': record.status === 'Pendiente',
              'table-success': record.status === 'Terminado',
            })}
          >
            {record.status}
          </td>
          <td className="text-center">{t('import.modules.' + record.modulo)}</td>
          <td className="text-center">{record.updated}</td>
          <td className="text-center">{record.inserted}</td>
          <td className="text-center">{record.fail}</td>
          <td className="text-center">{record.warnings}</td>
          <td className="text-center">
            <ImportActions
              collapsed={collapsed}
              t={t}
              record={record}
              handleReImportCSV={handleReImportCSV}
              isImporting={isImporting}
              handleToggleCollapsed={this.handleToggleCollapsed}
            />
          </td>
        </tr>
        {!collapsed ? (
          <tr className={classnames('table-active', { 'd-none': collapsed })}>
            <td colSpan="7">
              <div className="table-reponsive position-relative">
                <table className="table table-condensed">
                  <thead>
                    <tr>
                      <th>{t('assets.fields.number')}</th>
                      <th>Nuevo</th>
                      <th>Exito</th>
                      <th>Advertencias</th>
                      <th>Errores</th>
                    </tr>
                  </thead>
                  <tbody>
                    {record.records.map((r) => (
                      <tr key={r.clave}>
                        <td width="10%">{r.number}</td>
                        <td width="10%">{t(r.new ? 'common.yes' : 'common.no')}</td>
                        <td
                          width="10%"
                          className={classnames({
                            'table-danger': !r.success,
                            'table-success': r.success,
                          })}
                        >
                          {t(r.success ? 'common.yes' : 'common.no')}
                        </td>
                        <td width="35%">
                          <ul className="list-group">
                            {r.warnings.map((e, index) => (
                              <li key={index} className="list-group-item">
                                {e.error}
                              </li>
                            ))}
                          </ul>
                        </td>
                        <td width="35%">
                          <ul className="list-group">
                            {r.errors.map((e, index) => (
                              <li key={index} className="list-group-item">
                                {e.error}
                              </li>
                            ))}
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        ) : null}
      </Fragment>
    );
  };
}

export default translate()(ImportListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/list/ImportListRow.js